import { Card, PostMiniCardBase } from "./post-mini-card";
import { useState } from "react";
import { Button } from "../../../../components/ui/button";
import { MaxFormCount } from "../../bulk-create/constants";

export const PostMiniCardTabs = ({
  cards,
  onSelect,
  onCloseAll,
  onClose,
  onAddNewForm,
  showAddNewButton,
  onDuplicate,
}: {
  cards: Card[];
  onSelect: (card: Card) => void;
  onCloseAll: () => void;
  onClose: (card: Card) => void;
  onAddNewForm: () => void;
  showAddNewButton?: boolean;
  onDuplicate?: (card: Card) => void;
}) => {
  const [collapsedClusterIds, setCollapsedClusterIds] = useState<
    (string | undefined)[]
  >([]);
  const clusters = partitionByCluster(cards);
  const isReachedMaxFormCount = cards.length >= MaxFormCount;
  return (
    <div
      className="flex flex-col gap-[8px] p-[8px] rounded-l-[8px] shrink-0 w-[224px] "
      style={{
        backgroundColor: "var(--color-primary-37)",
        boxShadow: "inset -5px 0 8px -8px #88888869",
      }}
    >
      <div className="flex gap-[8px]">
        {showAddNewButton && (
          <Button
            variant="blue-secondary"
            onClick={() => {
              onAddNewForm();
            }}
            name="plus"
            size="xs"
            className="flex-1 drop-shadow-sm bg-white border-0"
            disabled={isReachedMaxFormCount}
          >
            <i className="fa fa-plus" />
          </Button>
        )}

        <Button
          variant="black-secondary"
          size="xs"
          className="flex-1 drop-shadow-sm border-0"
          onClick={onCloseAll}
        >
          Close all <i className="fa fa-close text-[16px]" />
        </Button>
      </div>
      {clusters.map((cards, idx) => {
        const cardsJsx = cards.map((card) => (
          <div key={card.postId}>
            <PostMiniCardBase
              card={card}
              onClick={() => onSelect(card)}
              onClose={() => onClose(card)}
              onDuplicate={() => onDuplicate?.(card)}
              showDuplicate={
                card.form?.requestType === "create" && !isReachedMaxFormCount
              }
            />
          </div>
        ));
        if (cards.length <= 1) {
          return (
            <div
              className="flex flex-col gap-[8px]"
              key={cards[0]?.clusterId || idx}
            >
              {cardsJsx}
            </div>
          );
        }
        return (
          <div
            className="flex flex-col pl-[8px] pr-[8px] pt-[8px] pb-[4px] mr-[-8px] gap-[4px] shadow-md rounded-l-[8px] bg-blue-50"
            key={cards[0]?.clusterId || idx}
            style={{
              clipPath: "inset(-10px 0px -10px -10px)",
            }}
          >
            <div
              className="flex gap-[4px] items-baseline text-blue-500 text-[12px] cursor-pointer"
              onClick={() => {
                if (collapsedClusterIds.includes(cards[0]?.clusterId)) {
                  setCollapsedClusterIds(
                    collapsedClusterIds.filter(
                      (id) => id !== cards[0]?.clusterId
                    )
                  );
                } else {
                  setCollapsedClusterIds([
                    ...collapsedClusterIds,
                    cards[0]?.clusterId,
                  ]);
                }
              }}
            >
              <i className="fa fa-hexagon-nodes text-[12px]" />
              <span className="font-semibold">Cluster</span>
              <i
                className={`fa ${collapsedClusterIds.includes(cards[0]?.clusterId) ? "fa-chevron-down" : "fa-chevron-up"} text-[12px]`}
              />
            </div>
            <div
              className={`flex flex-col gap-[8px] mb-[4px] ${collapsedClusterIds.includes(cards[0]?.clusterId) ? "hidden" : ""}`}
            >
              {cardsJsx}
            </div>
          </div>
        );
      })}
    </div>
  );
};

function partitionByCluster(cards: Card[]) {
  const clusters = new Map<string, Card[]>();
  for (const card of cards) {
    const clusterId = card.clusterId || card.postId;
    if (!clusters.has(clusterId)) {
      clusters.set(clusterId, []);
    }
    clusters.get(clusterId)!.push({
      ...card,
      clusterId,
    });
  }
  return [...clusters.values()];
}
